import Form        from "../../components/Form/Form";

import "./login.css";
import SubmitButton from "../../components/Form/FormElements/SubmitButton";
import TextInput    from "../../components/Form/FormElements/TextInput";

import { Link, useNavigate }               from "react-router-dom";
import { useState, useEffect, useContext, useCallback } from "react";
import Cookies                             from "js-cookie";

import axios      from "axios";

import config from "../../Config";

import useUser from "../../hooks/User";
import { ErrorHandlerContext, ErrorHandlerContextProvider } from "../../contexts/ErrorHandlerContext";
import ErrorHandler from "../../components/common/ErrorHandler";
import { ROUTES } from "../../routes";
import { safeStartViewTransition } from "../../utils/viewTransition";
import SEO from "../../components/SEO";

function LoginCodeForm() {

    const { setErrorList } = useContext(ErrorHandlerContext);
    const [code, setCode]  = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const nav              = useNavigate();
    
    const changeCallback   = useCallback(e  => setCode(e.target.value), [setCode]);
    const submitCallback   = useCallback(() => {

        setIsLoading(true);

        axios.get("/general/register_or_authenticate", {

            params: {

                verification_code_value: code

            }

        })
            .then((response) => {

                if (200 <= response.status && response.status < 300) {

                    const userValue = response.data.value;
                    Cookies.set(config.authCookie, userValue, {
                        expires: 30 * 6
                    });

                    // Notify UserSessionContext to refetch user data
                    window.dispatchEvent(new CustomEvent('user:login'));

                    safeStartViewTransition(() => {
                        nav(ROUTES.PROFILE, {viewTransition: true});
                    });

                }

            })
            
            .catch((reason) => {
                
                setErrorList(prev => [...prev, reason.response.data.error_description]);

            })
            
            .finally(() => {
                setIsLoading(false);
            });

    }, [code, nav, setErrorList]);

    return (
        <Form callback={submitCallback}>
            <div className="auth-form-content">
                <TextInput 
                    name="code" 
                    label="Код подтверждения" 
                    pattern={"\\w{6}"} 
                    required={true} 
                    className="form-code-center" 
                    onchange={changeCallback}
                    initial={code}
                    placeholder="000000"
                />
                <SubmitButton value={isLoading ? "Вход..." : "Войти"} disabled={isLoading} />
            </div>
        </Form>
    );

}

function LoginCode() {

    const { error, loading }    = useUser();

    const nav = useNavigate();

    useEffect(() => {

        if (!error && !loading) nav(ROUTES.PROFILE, { viewTransition: true });

    }, [error, loading, nav]);

    return (
        <ErrorHandlerContextProvider>
            <SEO title="Подтверждение входа" description="Введите код подтверждения для входа в систему Spiria" noindex={true} />
            <div className="auth-page">
                <div className="auth-container">
                    <div className="auth-header">
                        <div className="auth-logo">
                            <svg 
                                version="1.0" 
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 294 295"
                            preserveAspectRatio="xMidYMid slice"
                                fill="currentColor"
                            >
                                <g transform="translate(0.000000,295.000000) scale(0.100000,-0.100000)"
                                   fill="#2f6fed"
                                   stroke="none">
                                    <path d="M1281 2855 c-215 -47 -403 -162 -535 -327 -294 -367 -266 -893 63
-1227 166 -168 402 -271 620 -271 l65 0 -39 -41 c-213 -220 -572 -258 -836
-87 -191 122 -309 340 -309 568 0 41 5 95 11 120 8 35 6 63 -7 130 -11 54 -18
135 -18 222 -1 131 -2 136 -19 120 -31 -27 -105 -145 -137 -217 -60 -133 -75
-213 -74 -385 1 -138 4 -165 27 -243 48 -155 117 -276 221 -385 333 -349 866
-385 1246 -85 196 155 314 377 344 648 l11 100 58 -70 c202 -244 221 -557 50
-817 -62 -94 -150 -171 -258 -224 -138 -68 -282 -90 -418 -63 -46 10 -70 8
-144 -7 -58 -12 -134 -18 -220 -18 -73 -1 -133 -2 -133 -3 0 -11 146 -106 215
-139 145 -71 223 -87 405 -87 140 0 164 2 243 26 167 51 303 134 418 253 110
116 177 232 225 389 25 82 27 104 27 245 0 182 -16 260 -87 405 -95 198 -248
347 -450 441 -92 42 -176 63 -306 78 l-105 12 70 57 c145 120 301 173 480 164
178 -10 304 -66 436 -197 149 -147 208 -302 195 -514 -4 -61 -8 -122 -8 -136
-1 -14 7 -71 16 -128 12 -67 17 -138 14 -206 -4 -122 -4 -122 77 -2 65 96 117
221 141 336 24 122 16 314 -20 433 -100 335 -365 578 -706 649 -131 28 -307
21 -433 -16 -384 -113 -651 -448 -669 -838 -2 -38 -5 -68 -8 -68 -13 0 -90 89
-122 140 -234 373 -62 852 359 1001 72 26 269 37 337 20 36 -9 58 -8 113 6 47
11 116 16 220 17 84 1 153 3 153 6 0 9 -110 85 -177 122 -72 40 -182 79 -271
97 -73 15 -274 12 -351 -4z m290 -1230 c64 -42 99 -132 79 -204 -50 -187 -317
-189 -365 -3 -24 92 13 174 98 217 64 33 130 29 188 -10z"/>
                                </g>
                            </svg>
                        </div>
                        <h1 className="auth-title">Подтверждение</h1>
                        <p className="auth-subtitle">Введите код из письма</p>
                    </div>

                    <div className="auth-card">
                        <LoginCodeForm />
                    </div>

                    <Link to={ROUTES.AUTH} viewTransition onClick={() => safeStartViewTransition()} className="auth-back-link">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m15 18-6-6 6-6"></path>
                        </svg>
                        Изменить адрес почты
                    </Link>
                </div>
            </div>
            <ErrorHandler />
        </ErrorHandlerContextProvider>
    );

}

export default LoginCode;
